import api from './api';

/**
 * 活码统计服务
 */
class WeworkContactWayStatisticsService {
  
  /**
   * 获取活码统计汇总
   * @param {Object} params - 查询参数
   * @param {string} params.contactWayConfigId - 活码配置ID
   * @param {string} params.startDate - 开始日期
   * @param {string} params.endDate - 结束日期
   * @returns {Promise<Object>} 统计汇总数据
   */
  async getContactWaySummary(params) {
    try {
      const response = await api.post('/wework/contact-way/statistics/summary', params);
      return response.data;
    } catch (error) {
      console.error('获取活码统计汇总失败:', error);
      throw error;
    }
  }

  /**
   * 获取所有活码统计汇总
   * @param {Object} params - 查询参数
   * @param {string} params.startDate - 开始日期
   * @param {string} params.endDate - 结束日期
   * @returns {Promise<Array>} 所有活码统计汇总列表
   */
  async getAllContactWaysSummary(params) {
    try {
      const response = await api.post('/wework/contact-way/statistics/all-summary', params);
      return response.data;
    } catch (error) {
      console.error('获取所有活码统计汇总失败:', error);
      throw error;
    }
  }

  /**
   * 获取活码按日期统计
   * @param {Object} params - 查询参数
   * @param {string} params.contactWayConfigId - 活码配置ID
   * @param {string} params.startDate - 开始日期
   * @param {string} params.endDate - 结束日期
   * @returns {Promise<Array>} 按日期统计数据
   */
  async getContactWayDateStatistics(params) {
    try {
      const response = await api.post('/wework/contact-way/statistics/date-stats', params);
      return response.data;
    } catch (error) {
      console.error('获取活码日期统计失败:', error);
      throw error;
    }
  }

  /**
   * 获取活码按成员统计
   * @param {Object} params - 查询参数
   * @param {string} params.contactWayConfigId - 活码配置ID
   * @param {string} params.startDate - 开始日期
   * @param {string} params.endDate - 结束日期
   * @returns {Promise<Array>} 按成员统计数据
   */
  async getContactWayMemberStatistics(params) {
    try {
      const response = await api.post('/wework/contact-way/statistics/member-stats', params);
      return response.data;
    } catch (error) {
      console.error('获取活码成员统计失败:', error);
      throw error;
    }
  }

  /**
   * 获取活码详细统计查询
   * @param {Object} params - 查询参数
   * @returns {Promise<Object>} 分页统计详情数据
   */
  async getContactWayStatistics(params) {
    try {
              const response = await api.post('/wework/contact-way/statistics/query', params);
      return response.data;
    } catch (error) {
      console.error('获取活码详细统计失败:', error);
      throw error;
    }
  }

  /**
   * 获取成员活码汇总
   * @param {Object} params - 查询参数
   * @param {string} params.weworkUserId - 企微用户ID
   * @param {string} params.startDate - 开始日期
   * @param {string} params.endDate - 结束日期
   * @param {boolean} params.includeInactive - 是否包含无活动的活码
   * @returns {Promise<Object>} 成员活码汇总数据
   */
  async getMemberContactWaysSummary(params) {
    try {
              const response = await api.post('/wework/contact-way/statistics/member-contact-ways', params);
      return response.data;
    } catch (error) {
      console.error('获取成员活码汇总失败:', error);
      throw error;
    }
  }

  /**
   * 获取成员活码详情
   * @param {Object} params - 查询参数
   * @param {string} params.weworkUserId - 企微用户ID
   * @param {string} params.startDate - 开始日期
   * @param {string} params.endDate - 结束日期
   * @param {number} params.page - 页码
   * @param {number} params.size - 每页大小
   * @returns {Promise<Object>} 分页详情数据
   */
  async getMemberContactWayDetails(params) {
    try {
              const response = await api.post('/wework/contact-way/statistics/member-details', params);
      return response.data;
    } catch (error) {
      console.error('获取成员活码详情失败:', error);
      throw error;
    }
  }

  /**
   * 批量获取活码统计汇总（优化性能）
   * @param {Object} params - 查询参数
   * @param {Array<string>} params.contactWayConfigIds - 活码配置ID列表
   * @param {string} params.startDate - 开始日期（可选，null表示查询累计数据）
   * @param {string} params.endDate - 结束日期（可选，null表示查询累计数据）
   * @returns {Promise<Object>} 以configId为key的统计汇总Map
   */
  async getBatchSummary(params) {
    try {
      const response = await api.post('/wework/contact-way/statistics/batch-summary', params);
      return response.data;
    } catch (error) {
      console.error('批量获取活码统计汇总失败:', error);
      throw error;
    }
  }

  /**
   * 导出按天维度明细Excel
   * @param {Object} params
   * @param {string[]} params.contactWayConfigIds
   * @param {string} params.startDate - yyyy-MM-dd
   * @param {string} params.endDate - yyyy-MM-dd
   * @returns {Promise<Blob>}
   */
  async exportDaily(params) {
    try {
      const response = await api.post('/wework/contact-way/statistics/export/daily', params, {
        responseType: 'blob',
        timeout: 180000  // 导出操作设置3分钟超时
      });
      return response.data;
    } catch (error) {
      console.error('导出按天明细失败:', error);
      throw error;
    }
  }

  /**
   * 导出按时段维度汇总Excel
   * @param {Object} params
   * @param {string[]} params.contactWayConfigIds
   * @param {string} params.startDate - yyyy-MM-dd
   * @param {string} params.endDate - yyyy-MM-dd
   * @returns {Promise<Blob>}
   */
  async exportSummary(params) {
    try {
      const response = await api.post('/wework/contact-way/statistics/export/summary', params, {
        responseType: 'blob',
        timeout: 180000  // 导出操作设置3分钟超时
      });
      return response.data;
    } catch (error) {
      console.error('导出时段汇总失败:', error);
      throw error;
    }
  }
}

export default new WeworkContactWayStatisticsService(); 